var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25677 5.0916C6.93498 4.81426 6.91261 4.34354 7.20682 4.04021C9.84523 1.31993 14.1548 1.31993 16.7932 4.04021C17.0874 4.34354 17.065 4.81426 16.7432 5.0916C16.4214 5.36893 15.9221 5.34785 15.6279 5.04451C13.6155 2.96967 10.3845 2.96967 8.37213 5.04451C8.07793 5.34785 7.57856 5.36893 7.25677 5.0916Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36206 7.26245C9.04027 6.98512 9.0179 6.5144 9.31211 6.21106C10.7878 4.68957 13.2122 4.68957 14.6879 6.21106C14.9821 6.5144 14.9598 6.98512 14.638 7.26245C14.3162 7.53979 13.8168 7.51871 13.5226 7.21537C12.6729 6.33931 11.3271 6.33931 10.4774 7.21537C10.1832 7.51871 9.68385 7.53979 9.36206 7.26245Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9955 8C11.4457 8 11 8.44771 11 9C11 9.55228 11.4457 10 11.9955 10H12.0045C12.5543 10 13 9.55228 13 9C13 8.44771 12.5543 8 12.0045 8H11.9955Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14C2.44772 14 2 14.4477 2 15V19C2 19.5523 2.44772 20 3 20V21C3 21.5523 3.44772 22 4 22H8.92963C9.59834 22 10.2228 21.6658 10.5937 21.1094L11.1679 20.2481C11.5638 19.6543 12.4362 19.6543 12.8321 20.2481L13.4063 21.1094C13.7772 21.6658 14.4017 22 15.0704 22H20C20.5523 22 21 21.5523 21 21V20C21.5523 20 22 19.5523 22 19V15C22 14.4477 21.5523 14 21 14V13C21 12.4477 20.5523 12 20 12H4C3.44772 12 3 12.4477 3 13V14ZM17 19C15.8954 19 15 18.1046 15 17C15 15.8954 15.8954 15 17 15C18.1046 15 19 15.8954 19 17C19 18.1046 18.1046 19 17 19ZM9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15C8.10457 15 9 15.8954 9 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartCloud1);
export default __webpack_public_path__ + "static/media/smart-cloud-1.87add8a34b1ea5552990886186e67e49.svg";
export { ForwardRef as ReactComponent };